import { render, staticRenderFns } from "./WelcomeMessage.vue?vue&type=template&id=0300cd3f&scoped=true&"
import script from "./WelcomeMessage.vue?vue&type=script&lang=js&"
export * from "./WelcomeMessage.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeMessage.vue?vue&type=style&index=0&id=0300cd3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0300cd3f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VDialog,VSheet})
